import {
  BreakpointQueryName, getRemSize, getTypography, ThemedFunctor, TypographyName,
} from '@doveit/bricks';
import { css } from 'styled-components';

export const container: ThemedFunctor = ({ theme }) => css`
  border: 1px solid ${theme.color.border.neutral.default.high};
  border-radius: ${theme.remSize[75]};
  position: relative;
`;

export const preview: ThemedFunctor = ({ theme }) => css`
  border-radius: ${theme.remRounding['2XS']} ${theme.remRounding['2XS']} 0 0;
  overflow: hidden;
`;

export const content: ThemedFunctor = ({ theme }) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.remSize[200]};
  padding: ${theme.remSize[200]};
`;

export const info: ThemedFunctor = ({ theme }) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.remSize[75]};
  margin-bottom: ${theme.remSize[200]};
`;

const TITLE_LINES = 2;

export const titleWrapper: ThemedFunctor = ({ theme }) => {
  const bodyTypo = theme.typographyScale[TypographyName.BODY];
  const mobileLineHeight = getRemSize(bodyTypo.variants.mobile.lineHeight);
  const desktopLineHeight = getRemSize(bodyTypo.variants.desktop.lineHeight);

  return css`
    ${getTypography(theme, TypographyName.BODY)}
    font-weight: 500;
    height: calc(${mobileLineHeight} * ${TITLE_LINES});
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: ${TITLE_LINES};
    -webkit-box-orient: vertical;

    ${theme.breakpoints.up(BreakpointQueryName.MD)} {
      height: calc(${desktopLineHeight} * ${TITLE_LINES});
    }
  `;
};

export const primaryActionWrapper: ThemedFunctor = () => css`
  flex: 1 0 0;
  min-width: 0;

  > * {
    width: 100%;
  }
`;
